/* eslint-disable no-unused-vars */
import React from 'react'
import { Redirect } from 'react-router-dom'

//Business Point Pages
import BusinessPointList from '../../Base/pages/BusinessPointNoRole'
import BusinessPointInfo from '../../Base/pages/BusinessPointNoRole/info'
import BusinessPointPlanogram from '../pages/BusinessPoint/planogram'
import BusinessPointInfoPlanogram from '../../Base/pages/BusinessPointNoRole/infoPlanogram'
import BusinessPointCalibration from '../pages/BusinessPoint/Calibrations'
import BusinessPointStock from '../pages/Stock/stockBusinessPoint'
import BusinessPointQrCode from '../pages/BusinessPoint/qrCode'

import NestleProduct from '../../SvNestleFranke/pages/Product'
import NestleProductInfo from '../../SvNestleFranke/pages/Product/ingredients'
import NestleProductCreate from '../../SvNestleFranke/pages/Product/info'
import HistoryPlanogram from "../../Base/pages/BusinessPointNoRole/historyPlanogram"
import RefundList from '../../Base/pages/TransactionNoRole/Transaction-refund/index'
import NestleIngredient from '../../SvNestleFranke/pages/Ingredient'
import NestleIngredientCreate from '../../SvNestleFranke/pages/Ingredient/create'

// Transaction Pages
import TransactionList from '../../Base/pages/TransactionNoRole/index'
import TransactionReport from '../../Base/pages/TransactionNoRole/Transaction-report'
import SnapshotReport from '../pages/Transactions/snapshot'
import SnapshotDistributor from '../pages/Transactions/snapshot-distributor'
import SnapshotRefiller from '../pages/Transactions/snapshot-refiller'

// Transaction Pages
import StockBusinessPoint from '../../SvNestleFranke/pages/Stock/BusinessPoints'
import StockWarehouse from '../../SvNestleFranke/pages/Stock/Warehouse'
import StockDeliveryOrder from '../../SvNestleFranke/pages/Stock/DeliveryOrder'
import TransactionDetail from '../../Base/pages/TransactionNoRole/detail'
// Dashboard
import DashboardNestle from '../pages/Dashboard/index'
import Dashboard from '../../SvNestleFranke/pages/Dashboard/index'

import UserProfile from '../../Base/pages/Authentication/UserProfile'

import AlertList from '../../SvNestleFranke/pages/Alert/index'
import AlertDeviceList from '../../SvNestleFranke/pages/Alert/alertdevice'

import NestleRefiller from '../../SvNestleFranke/pages/Refiller/index'
import NestleCreateRefiller from '../../SvNestleFranke/pages/Refiller/create'
import NestleDistributor from '../../SvNestleFranke/pages/Distributor/index'
import NestleCreateDistributor from '../../SvNestleFranke/pages/Distributor/create'
import BankAccount from "../pages/Payout/bankAccount"
import PayoutReport from "../pages/Payout/index"
import InfoBank from "../pages/Payout/info"
import CsV from '../../SvNestleFranke/pages/Csv/csv'
import couponList from "../pages/Coupon/index"

import RFID from '../pages/RFID/index'
import TransactionRFID from '../pages/RFID/transaction'
let role = ''
const obj = JSON.parse(localStorage.getItem('role'))
if (obj != null) {
  role = obj.role
}
const svFrankeRoutes = [
  // Nestle routes
  { path: '/dashboard', component: Dashboard },
  { path: '/csv', component: CsV },
  // Payout
  { path: "/payout/list", component: PayoutReport },
  { path: "/payout/bankaccount", component: BankAccount },
  { path: "/payout/create/bankaccount", component: InfoBank },
  { path: "/payout/edit/:id", component: InfoBank },
  { path: "/coupon/list", component: couponList },
  // profile
  { path: '/profile', component: UserProfile },
  /* Business point */
  { path: '/business-point/list', component: BusinessPointList },
  { path: '/business-point/create', component: BusinessPointInfo },
  { path: '/business-point/info/:id', component: BusinessPointInfo },
  { path: '/business-point/planogram/:id', component: BusinessPointPlanogram },
  { path: '/business-point/edit/:id', component: BusinessPointInfoPlanogram },
  { path: '/business-point/alert/:id', component: AlertDeviceList },
  { path: '/business-point/options/:id', component: BusinessPointCalibration },
  { path: '/business-point/stock/:id', component: BusinessPointStock },
  { path: '/business-point/qrCode/:id', component: BusinessPointQrCode },
  { path: "/business-point/history/planogram", component: HistoryPlanogram },
  { path: "/refund/list", component: RefundList },

  // product
  { path: '/product/list', component: NestleProduct },
  { path: '/product/ingredient', component: NestleProductInfo },
  { path: '/product/create', component: NestleProductCreate },
  { path: '/product/edit/:id', component: NestleProductCreate },

  { path: '/ingredient/list', component: NestleIngredient },
  { path: '/ingredient/create', component: NestleIngredientCreate },
  { path: '/ingredient/edit/:id', component: NestleIngredientCreate },

  // transaction
  { path: '/transaction/list', component: TransactionList },
  { path: '/transaction/report', component: TransactionReport },
  { path: '/transaction/snapshot', component: SnapshotReport },
  { path: '/snapshot/distributor', component: SnapshotDistributor },
  { path: '/snapshot/refiller', component: SnapshotRefiller },
  { path: '/transaction/detail/:id', component: TransactionDetail},
  //Refiller
  { path: '/refill/list', component: NestleRefiller },
  { path: '/refill/create', component: NestleCreateRefiller },
  { path: '/refill/edit/:id', component: NestleCreateRefiller },

  //Distributor
  { path: '/distributor/list', component: NestleDistributor },
  { path: '/distributor/create', component: NestleCreateDistributor },
  { path: '/distributor/edit/:id', component: NestleCreateDistributor },

  { path: '/alert/list', component: AlertList },

  // stock
  { path: '/stock/business-point', component: StockBusinessPoint },
  { path: '/stock/warehouse', component: StockWarehouse },
  { path: '/stock/create-do', component: StockDeliveryOrder },
  // eslint-disable-next-line react/display-name

  // RFID
  { path: '/RFID/list/:id', component: RFID },
  { path: '/transaction/rfid', component: TransactionList},
  {
    path: '/',
    exact: true,
    component: () =>
      role == 'distributor' ? (
        <Redirect to="/business-point/list" />
      ) : role == 'refill' ? (
        <Redirect to="/business-point/list" />
      ) : (
        <Redirect to="/dashboard" />
      ),
  },
]

export { svFrankeRoutes }
